
export class LoansDto {
    loanId?: number;
    loanAccountNumber:string;
    emi: number;
    totalReceivable:number;
    totalPaid:number;
    currentMonthDueDate:Date;
    currentMonthEmi:number;
    customerName:string;
    mobileNumber:string;   
  }
  
  export const LoansDtoDefault : LoansDto = {
    loanId: 0,
    loanAccountNumber:"",
    emi: 0,
    totalReceivable:0,
    totalPaid:0,
    currentMonthDueDate:new Date(),
    currentMonthEmi:0,
    customerName:"",
    mobileNumber:"",
    
  };
  
  